import { render, staticRenderFns } from "./LeftNav.vue?vue&type=template&id=b6a60dec&scoped=true&"
import script from "./LeftNav.vue?vue&type=script&lang=js&"
export * from "./LeftNav.vue?vue&type=script&lang=js&"
import style0 from "./LeftNav.vue?vue&type=style&index=0&id=b6a60dec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6a60dec",
  null
  
)

export default component.exports